/**
 * Service pour la vérification de version
 * Aucune logique métier, uniquement des appels API
 */

import { api, endpoints } from './api.js'

export const versionService = {
  check: () => api.get(endpoints.version.check())
}
